import InfoIcon from '@mui/icons-material/Info';
import { Tooltip } from '@mui/material';

type Props = {
    title: string;
};

const TooltipInfo = ({ title }: Props) => (
    <Tooltip title={title}>
        <InfoIcon color="primary" />
    </Tooltip>
);

export default TooltipInfo;
